// Autogenerated file
import headerControls from './headerControls';

export default {
  ...headerControls,
};
